import type { RawSchemaFilter } from '@/services/resolvers/domain/filterSchema/schemaGenerator'

export const smsSurveyRepliesTableFilterFields = {
  question: 'questionId',
}

export const smsSurveyRepliesTableSchemaFilters: RawSchemaFilter[] = [smsSurveyRepliesTableFilterFields.question]
